module.exports = __webpack_public_path__ + "static/cc_by_sa-331e6b36b956cea4190238d9efae9224.png";